/* CRO home page (4WDCraft): category menu, hero slider, product tabs + carousel, quick add */
(function () {
  function init(root) {
    if (root.getAttribute('data-chm-ready')) return;
    root.setAttribute('data-chm-ready', '1');
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

    /* browse-all mega menu: click to toggle, hover on desktop */
    var browse = root.querySelector('[data-browse]'), drop = root.querySelector('[data-drop]'), ht;
    var desk = window.matchMedia('(hover: hover) and (min-width: 990px)');
    function setOpen(open) {
      if (!drop) return;
      drop.classList.toggle('is-open', open);
      browse.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (browse && drop) {
      browse.addEventListener('click', function () { setOpen(!drop.classList.contains('is-open')); });
      [browse, drop].forEach(function (el) {
        el.addEventListener('mouseenter', function () { if (desk.matches) { clearTimeout(ht); setOpen(true); } });
        el.addEventListener('mouseleave', function () { if (desk.matches) { clearTimeout(ht); ht = setTimeout(function () { setOpen(false); }, 250); } });
      });
      document.addEventListener('click', function (e) {
        if (!drop.classList.contains('is-open')) return;
        if (drop.contains(e.target) || browse.contains(e.target)) return;
        setOpen(false);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    }

    /* slider */
    var slides = $$('[data-slide]'), dotsBox = root.querySelector('[data-dots]'), dots = [], cur = 0, timer;
    if (dotsBox && slides.length > 1) {
      slides.forEach(function (s, k) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'chm-dot disable-global-button-styling';
        d.setAttribute('aria-label', 'Slide ' + (k + 1));
        d.setAttribute('aria-selected', k === 0 ? 'true' : 'false');
        d.addEventListener('click', function () { go(k); play(); });
        dotsBox.appendChild(d); dots.push(d);
      });
    }
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
    }
    function play() { clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { go(cur + 1); }, 6000); }
    var slider = root.querySelector('[data-slider]');
    if (slider) {
      var sx = null;
      slider.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        if (sx === null || (drop && drop.contains(e.target))) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); play(); }
      });
    }
    play();

    /* featured tabs + carousel */
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    function arrows() {
      if (!track || !prev || !next) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function step() { var c = track.querySelector('[data-card]:not([hidden])'); return c ? c.getBoundingClientRect().width + 12 : 260; }
    if (track) {
      track.addEventListener('scroll', arrows, { passive: true });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      window.addEventListener('resize', arrows);
      arrows();
    }
    $$('[data-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-tab');
        $$('[data-tab]').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        $$('[data-card]').forEach(function (c) { c.hidden = id !== 'all' && c.getAttribute('data-cat') !== id; });
        if (track) { track.scrollLeft = 0; arrows(); }
      });
    });

    /* car tips slider (phone): arrows + dots follow the swipe */
    var tips = root.querySelector('[data-tips]');
    if (tips) {
      var tcards = Array.prototype.slice.call(tips.children), tdBox = root.querySelector('[data-tdots]'), tdots = [];
      var tp = root.querySelector('[data-tprev]'), tn = root.querySelector('[data-tnext]');
      var tstep = function () { return tcards[0] ? tcards[0].getBoundingClientRect().width + 12 : 300; };
      if (tdBox && tcards.length > 1) {
        tcards.forEach(function (c, k) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'chm-tdot disable-global-button-styling';
          d.setAttribute('aria-label', 'Tip ' + (k + 1));
          d.addEventListener('click', function () { tips.scrollTo({ left: k * tstep(), behavior: 'smooth' }); });
          tdBox.appendChild(d); tdots.push(d);
        });
      }
      var tsync = function () {
        var max = tips.scrollWidth - tips.clientWidth;
        var i = tips.scrollLeft >= max - 4 ? tcards.length - 1 : Math.round(tips.scrollLeft / tstep());
        tdots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (tp) tp.disabled = tips.scrollLeft < 4;
        if (tn) tn.disabled = tips.scrollLeft >= max - 4;
      };
      if (tp) tp.addEventListener('click', function () { tips.scrollBy({ left: -tstep(), behavior: 'smooth' }); });
      if (tn) tn.addEventListener('click', function () { tips.scrollBy({ left: tstep(), behavior: 'smooth' }); });
      tips.addEventListener('scroll', tsync, { passive: true });
      window.addEventListener('resize', tsync);
      tsync();
    }

    /* add to cart */
    var toast = root.querySelector('[data-toast]'), tt;
    function showToast(msg) {
      if (!toast) return;
      toast.querySelector('[data-toast-text]').textContent = msg;
      toast.hidden = false; clearTimeout(tt);
      tt = setTimeout(function () { toast.hidden = true; }, 4000);
    }
    function add(btn, items, label) {
      var old = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      fetch(root.getAttribute('data-add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          btn.classList.add('is-done'); btn.textContent = 'Added ✓';
          showToast(label);
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          }).catch(function () {});
          setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = old; btn.disabled = false; }, 2500);
        })
        .catch(function (e) {
          btn.textContent = old; btn.disabled = false;
          showToast((e && (e.description || e.message)) || 'Could not add. Please try again.');
        });
    }
    $$('[data-add-one]').forEach(function (b) {
      b.addEventListener('click', function () { add(b, [{ id: parseInt(b.getAttribute('data-add-one'), 10), quantity: 1 }], 'Added. Add 1 more item to save 10%.'); });
    });
    $$('[data-add-two]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ids = b.getAttribute('data-add-two').split(',');
        add(b, ids.map(function (i) { return { id: parseInt(i, 10), quantity: 1 }; }), 'Bundle added. 10% off applies at checkout.');
      });
    });
  }
  function all() { document.querySelectorAll('[data-chm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
